import { SerpStockAdjustmentSnapshot } from '@/components/Approval/@components/SerpStockAdjustment';
import { parseSerpContent } from '@/utils/approval/serpDocument';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 169 SERP 재고실사 조정 — 저장 content 그대로(레거시 조회와 동일) */
const SerpStockAdjustmentSlot = ({ data }: ContentExtraProps) => {
  const content = parseSerpContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <SerpStockAdjustmentSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default SerpStockAdjustmentSlot;
